var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getWidgetHtml } from './markup';
import Swiper from 'swiper';
import { Navigation, EffectFade, Thumbs, Mousewheel } from 'swiper/modules';
export default class LightboxWidget {
    constructor(options = {}) {
        this.initialSlide = 0;
        this.options = Object.assign(Object.assign({}, LightboxWidget.defaults()), options);
        this.init();
    }
    static defaults() {
        return {
            baseClass: 'lightbox',
            thumbnails: true,
        };
    }
    init() {
        document.addEventListener('click', this.handleDocumentClick.bind(this));
        document.addEventListener('keydown', this.handleDocumentKeyDown.bind(this));
        this.items = [];
        this.initialSlide = 0;
    }
    destroy() {
        document.removeEventListener('click', this.handleDocumentClick.bind(this));
    }
    static hasAnimation(element) {
        const style = window.getComputedStyle(element);
        return style.animationName !== 'none' || style.transitionDuration !== '0s';
    }
    isOpen() {
        var _a;
        return Boolean((_a = this.widget) === null || _a === void 0 ? void 0 : _a.classList.contains('is-open'));
    }
    handleDocumentClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = event.target;
            const trigger = target.closest('a[data-lightbox]');
            if (trigger) {
                event.preventDefault();
                this.updateItems(trigger);
                yield this.openWidget();
            }
            const btnClose = target.closest('[data-lightbox-close]');
            if (btnClose) {
                yield this.closeWidget();
            }
        });
    }
    updateItems(trigger) {
        var _a;
        const addItem = (element) => {
            var _a, _b, _c, _d, _e;
            if (!element)
                return;
            this.items.push({
                src: (_a = element.getAttribute('href')) !== null && _a !== void 0 ? _a : '',
                srcset: (_b = element.dataset.srcset) !== null && _b !== void 0 ? _b : '',
                alt: (_c = element.dataset.alt) !== null && _c !== void 0 ? _c : '',
                label: (_d = element.dataset.label) !== null && _d !== void 0 ? _d : '',
                caption: (_e = element.dataset.caption) !== null && _e !== void 0 ? _e : '',
            });
        };
        const galleryId = (_a = trigger.getAttribute('data-lightbox')) !== null && _a !== void 0 ? _a : '';
        this.items = [];
        this.initialSlide = 0;
        if (galleryId) {
            const triggers = document.querySelectorAll(`[data-lightbox="${galleryId}"]`);
            triggers.forEach((el, index) => {
                if (el === trigger) {
                    this.initialSlide = index;
                }
                addItem(el);
            });
        }
        else {
            addItem(trigger);
        }
    }
    openWidget() {
        return __awaiter(this, void 0, void 0, function* () {
            const doOpen = () => {
                if (this.widget) {
                    this.widget.classList.remove('is-opening');
                    this.widget.classList.add('is-open');
                    // this.emit('open');
                }
            };
            if (this.widget) {
                if (this.isOpen()) {
                    yield this.closeWidget();
                }
                this.destroyWidget();
            }
            this.widget = this.createWidget();
            this.initSwiper();
            this.widget.querySelectorAll('img[loading="lazy"]').forEach((img) => {
                var _a;
                const preloader = document.createElement('div');
                // preloader.classList.add('swiper-lazy-preloader');
                // preloader.classList.add('swiper-lazy-preloader-white');
                preloader.classList.add('lazy-preloader');
                preloader.classList.add('lazy-preloader--white');
                (_a = img.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(preloader);
            });
            if (this.widget) {
                // this.emit('beforeOpen');
                this.widget.classList.add('is-opening');
                // this.disableScrolling();
                yield new Promise((resolve) => {
                    if (this.widget && LightboxWidget.hasAnimation(this.widget)) {
                        const onAnimationEnd = () => {
                            var _a;
                            (_a = this.widget) === null || _a === void 0 ? void 0 : _a.removeEventListener('animationend', onAnimationEnd);
                            resolve();
                        };
                        this.widget.addEventListener('animationend', onAnimationEnd);
                    }
                    else {
                        resolve();
                    }
                });
                doOpen();
            }
        });
    }
    closeWidget() {
        return __awaiter(this, void 0, void 0, function* () {
            const doClose = () => {
                if (this.widget) {
                    this.widget.classList.remove('is-closing');
                    this.widget.classList.remove('is-open');
                    // this.enableScrolling();
                    // this.emit('close');
                    this.destroySwiper();
                    this.destroyWidget();
                    this.widget = null;
                }
            };
            // this.emit('beforeClose');
            if (this.widget) {
                this.widget.classList.add('is-closing');
                if (LightboxWidget.hasAnimation(this.widget)) {
                    yield new Promise((resolve) => {
                        var _a;
                        const onAnimationEnd = () => {
                            var _a;
                            (_a = this.widget) === null || _a === void 0 ? void 0 : _a.removeEventListener('animationend', onAnimationEnd);
                            resolve();
                        };
                        (_a = this.widget) === null || _a === void 0 ? void 0 : _a.addEventListener('animationend', onAnimationEnd);
                    });
                }
                doClose();
            }
        });
    }
    createWidget() {
        const widget = document.createElement('div');
        widget.classList.add('lightbox');
        widget.classList.toggle('lightbox--gallery', this.items.length > 1);
        const showThumbs = (this.items.length > 1) && this.options.thumbnails;
        widget.classList.toggle('lightbox--thumbnails', showThumbs);
        widget.innerHTML = getWidgetHtml(this.items, this.options);
        document.body.append(widget);
        return widget;
    }
    destroyWidget() {
        if (this.widget) {
            this.widget.remove();
        }
    }
    initSwiper() {
        if (!this.widget || this.items.length < 2)
            return;
        if (this.mainSwiper)
            this.destroySwiper();
        const sliderElement = this.widget.querySelector('.lightbox__slider');
        if (!sliderElement)
            return;
        const btnPrev = this.widget.querySelector('.lightbox__prev') || null;
        const btnNext = this.widget.querySelector('.lightbox__next') || null;
        const thumbsSliderElement = this.widget.querySelector('.lightbox__thumbs-slider');
        if (thumbsSliderElement) {
            this.thumbsSwiper = new Swiper(thumbsSliderElement, {
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 20,
                direction: 'vertical',
                // freeMode: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                initialSlide: this.initialSlide,
            });
        }
        this.mainSwiper = new Swiper(sliderElement, {
            modules: [Navigation, EffectFade, Thumbs, Mousewheel],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 0,
            speed: 500,
            navigation: {
                prevEl: btnPrev,
                nextEl: btnNext,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            initialSlide: this.initialSlide,
            thumbs: {
                swiper: this.thumbsSwiper,
                autoScrollOffset: 0,
                multipleActiveThumbs: false,
            },
            slideToClickedSlide: true,
            mousewheel: {
                enabled: true,
            },
        });
    }
    destroySwiper() {
        if (this.thumbsSwiper) {
            this.thumbsSwiper.destroy();
            this.thumbsSwiper = null;
        }
        if (this.mainSwiper) {
            this.mainSwiper.destroy();
            this.mainSwiper = null;
        }
    }
    handleDocumentKeyDown(event) {
        var _a, _b;
        if (!this.mainSwiper)
            return;
        const slidesCount = ((_b = (_a = this.widget) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.lightbox__item')) === null || _b === void 0 ? void 0 : _b.length) || 0;
        switch (event.key) {
            case 'ArrowUp':
            case 'ArrowLeft':
                this.mainSwiper.slidePrev();
                break;
            case 'ArrowDown':
            case 'ArrowRight':
                this.mainSwiper.slideNext();
                break;
            case 'Home':
                this.mainSwiper.slideTo(0);
                break;
            case 'End':
                this.mainSwiper.slideTo(slidesCount - 1);
                break;
        }
    }
}
